import React from "react";
import styled from "styled-components";
import { ProductConsumer } from "../Context/AddProWakel";
import paradan from "./../img/paradan.jpg";
import darhenan from "./../img/darhenan.png";
import setting from "./../img/setting.jpg";
import wakel from "./../img/wakel.png";
import mandub from "./../img/mandub.png";
import wasl from "./../img/wasl.png";
import Navbar from "../Navbar/Navbar";
import change from "./../img/change.png";
import QarziAsto from "./../img/QarziAsto.png";

import { Link } from "react-router-dom";
const MasrufatList = () => {
  return (
    <>
      <ProductConsumer>
        {(value) => {
          const { QA_OpenModal, L_user } = value;
          return (
            <>
              <Navbar />
              <PageContainer>
                <PageHeader>
                  <h1 className="page-title">مەسروفات و کارەکان</h1>
                  <p className="page-subtitle">بەڕێوەبردنی مەسروفات و کارەکانی ڕۆژانە</p>
                </PageHeader>
                <div className="container mt-4">
                  <ProductWraper className="row">
                  <div className="col-9 mx-auto col-md-6 col-lg-3 my-3 pointer">
                    <div className="card ">
                      <div className="img-container p-5">
                        <Link to="/Mandub">
                          <img
                            src={mandub}
                            alt="product"
                            className="card-img-top "
                          />
                        </Link>
                      </div>
                      <div
                        className="card-footer d-flex justify-content-center  h2 "
                        style={{ color: "#2C3539" }}
                      >
                        <p className="align-self-center mb4 ">مافی.کۆمپانیا</p>
                      </div>
                    </div>
                    {/* <div className="card ">
                      <div className="img-container p-5">
                        <Link to="/Paradarhenan">
                          <img
                            src={darhenan}
                            alt="product"
                            className="card-img-top "
                          />
                        </Link>
                      </div>
                      <div
                        className="card-footer d-flex justify-content-center  h2 "
                        style={{ color: "#2C3539" }}
                      >
                        <p className="align-self-center mb4 ">پارە دەرهینان</p>
                      </div>
                    </div> */}
                  </div>

                  <div className="col-9 mx-auto col-md-6 col-lg-3 my-3 pointer">
                    <div className="card ">
                      <div className="img-container p-5">
                        <Link to="/input-masruf">
                          <img
                            src={setting}
                            alt="product"
                            className="card-img-top "
                          />
                        </Link>
                      </div>
                      <div
                        className="card-footer d-flex justify-content-center  h2 "
                        style={{ color: "#2C3539" }}
                      >
                        <p className="align-self-center mb4 ">مەسروف</p>
                      </div>
                    </div>
                  </div>

                  {/* bas */}
                  <div className="col-9 mx-auto col-md-6 col-lg-3 my-3 pointer">
                    <div className="card ">
                      <div className="img-container p-5">
                        <Link to="/Paradan">
                          <img
                            src={paradan}
                            alt="product"
                            className="card-img-top "
                          />
                        </Link>
                      </div>
                      <div
                        className="card-footer d-flex justify-content-center  h2"
                        style={{ color: "#2C3539" }}
                      >
                        <p className="align-self-center mb4 ">پارەدان</p>
                      </div>
                    </div>
                  </div>

                  <div className="col-9 mx-auto col-md-6 col-lg-3 my-3 pointer">
                    <div className="card ">
                      <div className="img-container p-5">
                        <Link to="/input-people">
                          <img
                            src={wakel}
                            alt="product"
                            className="card-img-top "
                          />
                        </Link>
                      </div>
                      <div
                        className="card-footer d-flex justify-content-center  h2 "
                        style={{ color: "#2C3539" }}
                      >
                        <p className="align-self-center mb4 ">کەسەکان</p>
                      </div>
                    </div>
                  </div>

                  <div className="col-9 mx-auto col-md-6 col-lg-3 my-3 pointer">
                    {/* <div className="card ">
                      <div className="img-container p-5">
                        <Link to="/parawargrtn">
                          <img
                            src={wasl}
                            alt="product"
                            className="card-img-top "
                          />
                        </Link>
                      </div>
                      <div
                        className="card-footer d-flex justify-content-center  h2 "
                        style={{ color: "#2C3539" }}
                      >
                        <p className="align-self-center mb4 ">
                          پارە گەڕاندنەوە
                        </p>
                      </div>
                    </div> */}
                  </div>

                  {/* change $ to ID */}
                  <div className="col-9 mx-auto col-md-6 col-lg-3 my-3 pointer">
                    {/* <div className="card ">
                      <div className="img-container p-5">
                        <Link to="/change-money">
                          <img
                            src={change}
                            alt="product"
                            className="card-img-top "
                          />
                        </Link>
                      </div>
                      <div
                        className="card-footer d-flex justify-content-center  h2 "
                        style={{ color: "#2C3539" }}
                      >
                        <p className="align-self-center mb4 ">پارەگۆڕینەوە</p>
                      </div>
                    </div> */}
                  </div>

                  <div className="col-9 mx-auto col-md-6 col-lg-3 my-3 pointer">
                    {/* <div className="card ">
                      <div className="img-container p-5">
                        <Link to="/Mandub">
                          <img
                            src={mandub}
                            alt="product"
                            className="card-img-top "
                          />
                        </Link>
                      </div>
                      <div
                        className="card-footer d-flex justify-content-center  h2 "
                        style={{ color: "#2C3539" }}
                      >
                        <p className="align-self-center mb4 ">مافی.کۆمپانیا</p>
                      </div>
                    </div> */}
                  </div>
                  <div className="col-9 mx-auto col-md-6 col-lg-3 my-3 pointer">
                    {/* <div className="card ">
                      <div className="img-container p-5">
                        <img
                          src={QarziAsto}
                          height="148px"
                          onClick={(e) => QA_OpenModal(e, L_user._id)}
                          alt="product"
                          className="card-img-top "
                        />
                      </div>
                      <div
                        className="card-footer d-flex justify-content-center  h2"
                        style={{ color: "#2C3539" }}
                      >
                        <p className="align-self-center mb4 "> قەرزی ئەستۆ</p>
                      </div>
                    </div> */}
                  </div>
                </ProductWraper>
              </div>
            </PageContainer>
            </>
          );
        }}
      </ProductConsumer>
    </>
  );
};

const PageContainer = styled.div`
  min-height: 100vh;
  background: linear-gradient(135deg, #1e272e 0%, #2C3539 50%, #34495e 100%);
  padding: 2rem 0;
`;

const PageHeader = styled.div`
  text-align: center;
  padding: 3rem 0 3rem;
  
  .page-title {
    color: #ffffff;
    font-size: 2.5rem;
    font-weight: 700;
    margin-bottom: 0.5rem;
    text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
  }
  
  .page-subtitle {
    color: #a8b2b8;
    font-size: 1.1rem;
    font-weight: 400;
  }
  
  @media (max-width: 768px) {
    padding: 2rem 0 2rem;
    
    .page-title {
      font-size: 2rem;
    }
    .page-subtitle {
      font-size: 1rem;
    }
  }
`;

const ProductWraper = styled.div`
  .card {
    border: none;
    border-radius: 15px;
    background: linear-gradient(145deg, #ffffff 0%, #f8f9fa 100%);
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
    transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
    overflow: hidden;
    height: 100%;
    
    &:hover {
      transform: translateY(-10px);
      box-shadow: 0 15px 40px rgba(0, 0, 0, 0.25);
      background: linear-gradient(145deg, #ffffff 0%, #e8f4f8 100%);
    }
  }

  .card-footer {
    background: linear-gradient(to top, rgba(44, 53, 57, 0.05), transparent);
    border-top: none;
    padding: 1.2rem;
    transition: all 0.4s ease;
    
    p {
      margin: 0;
      font-weight: 600;
      color: #2C3539;
      text-shadow: 0 1px 2px rgba(255, 255, 255, 0.8);
    }
  }
  
  .card:hover .card-footer {
    background: linear-gradient(to top, rgba(52, 152, 219, 0.1), transparent);
    
    p {
      color: #3498db;
    }
  }

  .img-container {
    position: relative;
    overflow: hidden;
    padding: 2rem !important;
    background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 200px;
    
    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: radial-gradient(circle at center, rgba(52, 152, 219, 0.1) 0%, transparent 70%);
      opacity: 0;
      transition: opacity 0.4s ease;
    }
    
    &:hover::before {
      opacity: 1;
    }
  }

  .card-img-top {
    transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
    filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.1));
    max-height: 150px;
    width: auto;
    object-fit: contain;
  }

  .img-container:hover .card-img-top {
    transform: scale(1.15) rotate(2deg);
    filter: drop-shadow(0 8px 16px rgba(52, 152, 219, 0.3));
  }

  .card-btn {
    position: absolute;
    bottom: 0;
    right: 0;
    padding: 0.2rem 0.4rem;
    background: linear-gradient(135deg, #3498db 0%, #2980b9 100%);
    border: none;
    color: #ffffff;
    font-size: 1.4rem;
    border-radius: 0.5rem 0 0 0;
    transform: translate(100%, 100%);
    transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
    box-shadow: 0 4px 15px rgba(52, 152, 219, 0.3);
  }

  .img-container:hover .card-btn {
    transform: translate(0, 0);
  }

  .card-btn:hover {
    background: linear-gradient(135deg, #2980b9 0%, #3498db 100%);
    color: #ffffff;
    cursor: pointer;
    box-shadow: 0 6px 20px rgba(52, 152, 219, 0.5);
  }

  .pointer {
    cursor: pointer;
  }

  /* Responsive adjustments */
  @media (max-width: 768px) {
    .card {
      margin-bottom: 1rem;
    }
    
    .img-container {
      min-height: 180px;
      padding: 1.5rem !important;
    }
  }
`;

export default MasrufatList;
